import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import {
  setAssessedBy,
  setDateTime,
  setSuccessfulAttempt,
  setAttempts,
  setAction,
} from '../../procedures/cardiac/store/cardiac.actions'
import { setAddCardiacToTimeline } from '../store/quickActions.actions'
import { getCardiacOptionsSelector, getVitalOptionsSelector } from '../../options/selectors'
import { ICardiacOptionsState, IVitalOptionsState } from '../../options/store/options.types'
import { trimAndReplaceForwardSlashWithUnderscore } from '../../../utilities/sanitize.util'

export function* setCardiacQuickAction() {
  const userId = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const cardiacOptionsState: ICardiacOptionsState = yield select(getCardiacOptionsSelector)
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)
  const { savedTimeString, currentDate, procedureAction } = props
  const { actionOptions } = cardiacOptionsState
  const actionOption = actionOptions.find(
    (option) =>
      trimAndReplaceForwardSlashWithUnderscore(option.id) === procedureAction || option.name === procedureAction
  )

  yield put(setDateTime(savedTimeString, currentDate))
  yield put(setAssessedBy(assessedByOption ? assessedByOption : null))
  yield put(setSuccessfulAttempt(true))
  yield put(setAttempts('1'))
  yield put(setAction(actionOption ? actionOption : null))
  yield put(setAddCardiacToTimeline(true))
}

export function* setCardiacQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_CARDIAC_BUTTON_TYPE], setCardiacQuickAction)
}
